import { render, staticRenderFns } from "./headerComp.vue?vue&type=template&id=58565480&scoped=true"
import script from "./headerComp.vue?vue&type=script&lang=js"
export * from "./headerComp.vue?vue&type=script&lang=js"
import style0 from "./headerComp.vue?vue&type=style&index=0&id=58565480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58565480",
  null
  
)

export default component.exports